import { FC } from "react";

type TSelectedOptionValuesDropdownProps = {
  title: string;
  values: string[];
};

const SelectedOptionValuesDropdown: FC<TSelectedOptionValuesDropdownProps> = ({
  title,
  values,
}) => {
  return (
    <div className="absolute top-full right-0 bg-white rounded-lg flex flex-col p-3 mt-2 w-48 shadow-lg border border-black/10 z-popup">
      <h4 className="font-semibold text-accent-blue-dark mb-4">{title}</h4>
      <ul className="flex flex-col gap-2 text-xs max-h-[calc(100vh-290px)] overflow-auto">
        {values.map((value, index) => (
          <li
            key={index}
            className={index > 0 ? `border-t border-t-border-gray pt-2` : ``}
          >
            {value}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SelectedOptionValuesDropdown;
